// links
export const MAILTO: string = "mailto:";
export const TEL: string = "tel:";
export const CALLTO: string = "callto:";
export const SMS: string = "sms:";

// deep linking
export const outlookDeepLink: string = "ms-outlook://";

// mailgo types
export const MAIL_TYPE: string = "mail";
export const TEL_TYPE: string = "tel";

// useful html tags
export const spanHTMLTag: string = "span";
export const aHTMLTag: string = "a";
export const pHTMLTag: string = "p";

// default lang
export const defaultLang: string = "en";
